import React, { useState } from "react";

import Table from "@Components/Table";
import Filter from "@Components/Filter";
import {
  DISTRICT_FETCH_URL,
  MOHR_BRANCH_BO_LIST_URL,
  MOHR_TERRITORIES_URL,
  STATE_FETCH_URL,
} from "configs/constants";

let model = [
  { id: "branch_name", label: "Branch Name", type: "string" },
  { id: "territory", label: "Territory", type: "string" },
  { id: "state_name", label: "State", type: "string" },
  { id: "district_name", label: "District", type: "string" },
  {
    id: "active",
    label: "Status",
    type: "boolean",
    yesValue: "Active",
    noValue: "Inactive",
  },
];

const filterInitialValues = {
  territory: "",
  state: "",
  district: "",
};

const pageNumberDropdown = true;


const BranchList = () => {
  const [filterValues, setFilterValues] = useState({});
  const [disableDistrict, setDisableDistrict] = useState(true);

  const actions = ["edit", "delete"];

  const filterFields = [
    {
      type: "reactselect",
      label: "Territory",
      name: "territory",
      proxyUrl: MOHR_TERRITORIES_URL,
      paginated: false,
    },
    {
      type: "reactselect",
      label: "State",
      name: "state",
      proxyUrl: STATE_FETCH_URL,
      getValue: (e) => getEstateValues(e, setDisableDistrict),

      paginated: true,
    },
    {
      type: "reactselect",
      label: "District",
      name: "district",
      proxyUrl: DISTRICT_FETCH_URL,
      disabled: disableDistrict,
      optionsDependsOn: "state",
      paginated: true,
    },
  ];
  const getEstateValues = (e, setDisableDistrict) => {
    if (!e || e.length === 0) {
      setDisableDistrict(true);
    }
    else {
      setDisableDistrict(false);
    }

  };

  const onFilterRequest = (values) => {
    let filterObj = {};
    for (const [key, value] of Object.entries(values)) {
      if (value !== null && value !== "") {
        filterObj[key] = value;
      }
    }
    setFilterValues(filterObj);
  };

  return (
    <>
      <div>
        <Filter
          initialValues={filterInitialValues}
          filterFields={filterFields}
          onSubmit={onFilterRequest}
        />
        <Table
          proxyURL={MOHR_BRANCH_BO_LIST_URL}
          actions={actions}
          model={model}
          filterValues={filterValues}
          pageNumberDropdown={pageNumberDropdown}

          noFilter
        />
      </div>
    </>
  );
};

export default BranchList;
